import * as Sentry from '@sentry/react';
import {Replay} from '@sentry/replay';

import {SENTRY_SAMPLING_RATE} from '../sentry.constants';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

const deploymentEnv = import.meta.env.VITE_DEPLOYMENT_ENV ?? 'development';

if (import.meta.env.NODE_ENV === 'production' && !sentryDsn) {
  // eslint-disable-next-line no-console
  console.error('VITE_SENTRY_DSN is undefined.');
}

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: deploymentEnv,
    tracesSampleRate: SENTRY_SAMPLING_RATE,
    integrations: (existing) => {
      if (deploymentEnv === 'production') {
        existing.push(
          new Replay({
            sessionSampleRate: 0,
            errorSampleRate: 1,
            maskAllText: false,
            maskAllInputs: false,
            unblock: ['svg', 'img', 'picture'],
          }),
        );
      }
      return existing;
    },
    ignoreErrors: ['Abort route change'],
  });
}

export {Sentry};
